import classNames from 'classnames'
import styles from './Inner.scss'

const Inner = ({ children, className, classNameOuter, background }) => (
  <div className={classNames(classNameOuter, styles[`bg-${background}`], 'px-xl-5')}>
    <div className={classNames('container', styles.base, className)}>{children}</div>
  </div>
)

Inner.defaultProps = {
  background: 'white',
}
Inner.propTypes = {}

export default Inner
